/**
 * Performance fast-path toggles. Read once at startup from localStorage
 * (`opencraft.perf.<name>` = '0' disables, '1' enables) so A/B runs need no
 * rebuild, e.g. in the console: localStorage['opencraft.perf.batch'] = '0'.
 */
function flag(name: string, def: boolean): boolean {
  try {
    const v = globalThis.localStorage?.getItem('opencraft.perf.' + name);
    if (v === '0') return false;
    if (v === '1') return true;
  } catch { /* no storage (worker / node) */ }
  return def;
}

export const PERF_FLAGS = {
  /** Region-batch chunk meshes (render/chunkBatch.ts): ~10x fewer draw calls. */
  batch: flag('batch', true),
  /** Also batch the translucent pass (chunks sorted back-to-front within a region). */
  batchTranslucent: flag('batchTranslucent', true),
};
